
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";
import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const {
        error
      } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      if (error) {
        throw error;
      }
      navigate("/admin");
    } catch (error: any) {
      toast.error(error.message || "Error al iniciar sesión");
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      {/* 3M Líder logo positioned above the login card */}
      <div className="mb-6">
        <img src="/lovable-uploads/b567a654-97e5-4401-9513-2574e8dbf7f0.png" alt="3M Líder Logo" className="h-auto w-auto max-h-24 object-contain" />
      </div>
      
      <div className={`w-full max-w-md p-8 space-y-6 bg-white rounded-2xl shadow-[0_4px_6px_-1px_rgba(0,0,0,0.05)] ${isMobile ? 'mx-8' : ''}`}>
        <div className="flex flex-col items-center justify-center space-y-4">
          <h1 className="text-3xl font-bold">Iniciar sesión</h1>
          <p className="text-gray-500">Ingresa tus credenciales para continuar</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="email" className="text-sm font-medium">Correo electrónico</label>
            <Input id="email" type="email" placeholder="tu@email.com" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="space-y-2">
            <label htmlFor="password" className="text-sm font-medium">
              Contraseña
            </label>
            <div className="relative">
              <Input 
                id="password" 
                type={showPassword ? "text" : "password"} 
                value={password} 
                onChange={e => setPassword(e.target.value)} 
                required 
              />
              <button 
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                onClick={togglePasswordVisibility}
                tabIndex={-1}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <Button type="submit" className="w-full" disabled={isLoading}>
            {isLoading ? "Iniciando sesión..." : "Iniciar sesión"}
          </Button>
        </form>
      </div>
      
      {/* Crescente logo below login component with same mb-6 spacing */}
      <div className="mt-6 flex flex-col items-center">
        <img src="https://crescente.es/wp-content/uploads/2025/03/cropped-icono-crescente-2.png" alt="Crescente Logo" className="h-auto w-auto max-h-8 object-contain opacity-75" />
        <p className="text-xs text-gray-300 mt-2">3M | Crescente © 2025</p>
      </div>
    </div>;
};
export default Login;
